var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKdsRush(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2408_6890",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2408_6890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8151 19C12.8586 19 11.2014 18.3211 9.84358 16.9632C8.48571 15.6054 7.80678 13.9482 7.80678 11.9917C7.80678 10.0498 8.48571 8.39904 9.84358 7.03943C11.2014 5.67981 12.8586 5 14.8151 5C16.757 5 18.4078 5.67981 19.7674 7.03943C21.127 8.39904 21.8068 10.0498 21.8068 11.9917C21.8068 13.9482 21.127 15.6054 19.7674 16.9632C18.4078 18.3211 16.757 19 14.8151 19ZM14.8068 18C16.4735 18 17.8901 17.4167 19.0568 16.25C20.2235 15.0833 20.8068 13.6667 20.8068 12C20.8068 10.3333 20.2235 8.91667 19.0568 7.75C17.8901 6.58333 16.4735 6 14.8068 6C13.1401 6 11.7235 6.58333 10.5568 7.75C9.39014 8.91667 8.80681 10.3333 8.80681 12C8.80681 13.6667 9.39014 15.0833 10.5568 16.25C11.7235 17.4167 13.1401 18 14.8068 18ZM17.2741 15.2058L17.9876 14.4923L15.3068 11.8115V8.3077H14.3068V12.2135L17.2741 15.2058ZM3.19141 8.5V7.5H6.80678V8.5H3.19141ZM2.19141 12.5V11.5H6.80678V12.5H2.19141ZM3.19141 16.5V15.5H6.80678V16.5H3.19141Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKdsRush);
export default __webpack_public_path__ + "static/media/kdsRush.ee7dbb4c9f53f4b0ae93625f94ae655f.svg";
export { ForwardRef as ReactComponent };